var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-hp-project-slider" }, [
    _c(
      "div",
      { staticClass: "teq-container" },
      [
        _vm.mobileVersion
          ? _c("mobile-hp-project-slider", {
              attrs: { slides: _vm.projectSlider }
            })
          : _c("desktop-hp-project-slider", {
              attrs: { slides: _vm.projectSlider }
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }